module.exports = __webpack_public_path__ + "img/regist-pop-up-mobile.b258ef8.png";